import Vue from "vue";
import VueI18n from "vue-i18n";
import Lockr from "lockr";
import store from "@/store"
import cache from '@/utils/cache'
import {checkLanguage} from '@/utils/dsbridge'
import langObj from '@/utils/locales/index'

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context(
        "./locales",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);

        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}
console.log("NADAOSHUJU ",langObj)

function getLanguage() {
    // let query=getCnashux()
    let query=null
    let healanguage=checkLanguage()
     let locale=store.state.app.lang?store.state.app.lang:healanguage
    //let locale=healanguage?healanguage:store.state.app.lang
    let Language1=''
    if (locale) {
        Language1=cache.getLanuageType(locale)
        return Language1;
    }else{
        // 使用系统语言，如果语言文件中没有则使用 en
        let demoyu=(navigator.language || navigator.userLanguage).split("-")[0]
        if(demoyu=='zh'){
            demoyu='zh-hk'
        }
        store.commit('SET_LANG', demoyu)
        return demoyu;
    }
}

function getCnashux(){
    let url=location.hash.substring(3)
    url=url.split('?')
    if(url && url.length>1){
        let query=url[1]
        query=query.split('&')
        let objectss={}
        for(let i in query){
            if(query[i]){
                let xinsh=query[i].split('=')
                if(xinsh && xinsh.length==2){
                    objectss[xinsh[0]]=xinsh[1]
                }
            }
        }

        return objectss
    }else{
        return false
    }
}

export default new VueI18n({
    locale: getLanguage(),
    fallbackLocale: "en",
    //messages: loadLocaleMessages(),
    messages:langObj,
    silentTranslationWarn: true
});


// WEBPACK FOOTER //
// ./src/utils/i18n.js